'use client';
import CloseButton from "./CloseButton.js";
export default CloseButton;